module.exports = __webpack_public_path__ + "img/icon-select.a57ddf82.svg";